import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { catchError, Observable, of } from "rxjs";

import { StateService } from "./state.service";
import { ApiUrlAdapter } from "../utils/ApiUrlAdapter";
import { MedLocaleTranslateList } from "../types.local";
import { MedLocalizationFilePath } from "../types";

@Injectable({
  providedIn: "root",
})
export class TranslatesApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly httpBackend: HttpBackend,
    private readonly state: StateService,
  ) {
    this._http = new HttpClient(httpBackend);
  }

  private _http: HttpClient;

  getData(path: MedLocalizationFilePath): Observable<MedLocaleTranslateList> {
    const { url } = new ApiUrlAdapter(this.state.apiUrl, this.state.locale, this.state.projectName, path);

    return this._http.get<MedLocaleTranslateList>(url).pipe(
      catchError(this._handleError("getData", {})),
    );
  }

  private _handleError(operation = "operation", result?: MedLocaleTranslateList) {
    return (error: any): Observable<MedLocaleTranslateList> => {
      if (this.state.isDebug) {
        this.state.logger.error(`${operation} failed: ${error.message}`);
      }

      return of(result as MedLocaleTranslateList);
    };
  }
}
